export const blockIconsMapsHandyman = (
	<span className='material-symbols-outlined'>handyman</span>
);
